import React from "react";
import { useAuth } from "../context/AuthContext";

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="container-fluid">
      {/* Seção Cabeçalho */}
      <div className="mt-3 mb-4">
        <h4>PARÓQUIA SÃO JOSÉ OPERÁRIO</h4>
        <h6>Pastoral de Eventos</h6>
        <div className="card shadow-sm p-3 mt-2">
          <p className="mb-1">Rua José Matos Correa, 244</p>
          <p className="mb-0">Sorocaba/SP</p>
        </div>
      </div>

      {/* Cards de resumo */}
      <div className="row g-4">
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm h-100">
            <div className="card-body d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="currentColor"
                className="me-3"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v4l3 1.5a.5.5 0 1 1-.5.866L8 9V4.5A.5.5 0 0 1 8 4z" />
                <path d="M8 1a7 7 0 1 0 7 7A7 7 0 0 0 8 1zm0 1a6 6 0 1 1-6 6A6 6 0 0 1 8 2z" />
              </svg>
              <div>
                <h5 className="card-title mb-1">Painel</h5>
                <p className="card-text mb-0">Visão geral do sistema</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm h-100">
            <div className="card-body d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="currentColor"
                className="me-3"
                viewBox="0 0 16 16"
              >
                <path d="M8.5.5v1.637l6 2.25v9.126l-6 2.25v1.637l7-2.625V2.125l-7-2.25z" />
                <path d="M1 2.125v10.313l7 2.625V12.25l-6-2.25V2.125l6-2.25V0.5l-7 2.625z" />
              </svg>
              <div>
                <h5 className="card-title mb-1">Produtos</h5>
                <p className="card-text mb-0">Gerencie os produtos</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm h-100">
            <div className="card-body d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="currentColor"
                className="me-3"
                viewBox="0 0 16 16"
              >
                <path d="M5 3a3 3 0 1 0 6 0 3 3 0 0 0-6 0z" />
                <path d="M2 13s-1 0-1-1 1-4 7-4 7 3 7 4-1 1-1 1H2z" />
              </svg>
              <div>
                <h5 className="card-title mb-1">Usuários</h5>
                <p className="card-text mb-0">Gerencie os usuários</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Seção adicional */}
      <div className="mt-5">
        <h4>Estatísticas recentes</h4>
        <div className="card shadow-sm p-3 mt-2">
          <p className="mb-0">Gráficos e informações resumidas.</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
